import { MenuItem, SelectChangeEvent } from '@mui/material';
import { ApplicationStatus, ApplicationType } from '@common-types';

import { ApplyingSchoolsFilters } from '@store/ApplyingSchoolsPlannerStore';
import useApplyingSchoolsPlannerStore from '@store/ApplyingSchoolsPlannerStore';

import { ALL_TYPES_FILTER_VALUE } from '@constants/educationPlanner';

import { ORDER_BY_EARLIEST, ORDER_BY_LATEST } from '@constants';

import {
  StyledContentSchoolListHeaderDivider,
  StyledContentSchoolListHeaderFilter,
  StyledContentSchoolListHeaderFilterGroup,
  StyledContentSchoolListHeaderFilterSelect,
  StyledContentSchoolListHeaderFilterText,
} from './Filters.styles';

interface FiltersProps {
  pageFilters: ApplyingSchoolsFilters;
  handleFilterChange: (filterName: string) => (event: SelectChangeEvent<unknown>) => void;
  handleOrderByChange: (event: SelectChangeEvent<unknown>) => void;
}

export const Filters = ({ pageFilters, handleFilterChange, handleOrderByChange }: FiltersProps) => {
  const { orderBy } = useApplyingSchoolsPlannerStore((state) => state);

  return (
    <StyledContentSchoolListHeaderFilterGroup>
      <StyledContentSchoolListHeaderFilter>
        <StyledContentSchoolListHeaderFilterText variant="body2" component="span">
          Application type:
        </StyledContentSchoolListHeaderFilterText>

        <StyledContentSchoolListHeaderFilterSelect
          value={pageFilters.applicationType}
          onChange={handleFilterChange('applicationType')}
        >
          <MenuItem value={ALL_TYPES_FILTER_VALUE}>All</MenuItem>

          <MenuItem value={ApplicationType.COMMON}>{ApplicationType.COMMON}</MenuItem>

          <MenuItem value={ApplicationType.INSTITUTIONAL}>{ApplicationType.INSTITUTIONAL}</MenuItem>
        </StyledContentSchoolListHeaderFilterSelect>
      </StyledContentSchoolListHeaderFilter>

      <StyledContentSchoolListHeaderDivider />

      <StyledContentSchoolListHeaderFilter>
        <StyledContentSchoolListHeaderFilterText variant="body2" component="span">
          Application status:
        </StyledContentSchoolListHeaderFilterText>

        <StyledContentSchoolListHeaderFilterSelect
          value={pageFilters.applicationStatus}
          onChange={handleFilterChange('applicationStatus')}
        >
          <MenuItem value={ALL_TYPES_FILTER_VALUE}>All</MenuItem>

          <MenuItem value={ApplicationStatus.NOT_STARTED}>{ApplicationStatus.NOT_STARTED}</MenuItem>

          <MenuItem value={ApplicationStatus.STARTED}>{ApplicationStatus.STARTED}</MenuItem>

          <MenuItem value={ApplicationStatus.SUBMITTED}>{ApplicationStatus.SUBMITTED}</MenuItem>

          <MenuItem value={ApplicationStatus.CANCELLED}>{ApplicationStatus.CANCELLED}</MenuItem>
        </StyledContentSchoolListHeaderFilterSelect>
      </StyledContentSchoolListHeaderFilter>

      <StyledContentSchoolListHeaderDivider />

      <StyledContentSchoolListHeaderFilter>
        <StyledContentSchoolListHeaderFilterText variant="body2" component="span">
          Application deadline:
        </StyledContentSchoolListHeaderFilterText>
        <StyledContentSchoolListHeaderFilterSelect value={orderBy} onChange={handleOrderByChange}>
          <MenuItem value={ORDER_BY_EARLIEST}>{ORDER_BY_EARLIEST}</MenuItem>

          <MenuItem value={ORDER_BY_LATEST}>{ORDER_BY_LATEST}</MenuItem>
        </StyledContentSchoolListHeaderFilterSelect>
      </StyledContentSchoolListHeaderFilter>
    </StyledContentSchoolListHeaderFilterGroup>
  );
};
